export default __webpack_public_path__ + "static/media/convert-card.b8e84948.svg";